{
  "global": {
    "website": "",
    "logoImgAlt": "Logo Img",
    "errorRequired": "This field is required",
    "errrorMin0": "At least one value must be provided",
    "avatarImgAlt": "Avatar Img",
    "wmlChipsplaceholder": "Type your value then press enter to see it appear",
    "wmlChipsuserInputsAriaLabel": "User Inputs",
    "wmlChipsremoveChipAriaLabel": "remove",
    "fillOutForm": "Please fill out all required fields",
    "loginAgain": "Please login again to continue using your account",
    "logoutError": "There was an issue while trying to log you out of your account please try again or contact support if the issue persists",
    "overlayLoading": "Loading ...",
    "siteUnderConstruction": "Site Under Construction",
    "formSubmitSuccess": "Form Submitted Sucessfully",
    "systemError": "An error has occured please try again later or contact support if the issue persists",
    "serviceUnavailableError":"The resource you requested is not available due to system maintenance, please try again in a few minutes",
    "submiBtn": "Submit",
    "comingSoon": "This feature is not availble yet, please try again later",
    "na": "N\\A",
    "countries": [
      "US"
    ],
    "states": [
      "AL",
      "AK",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "FL",
      "GA",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "OH",
      "OK",
      "OR",
      "PA",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY"
    ],
    "wmlSelect": {
      "select": "Please Select"
    }
  },
  "LabViewerZero": {
    "toggleREADME": "Toggle Guide",
    "wmlNotify": {
      "noGuideAvailable": "There is no guide avaiable for this lab"
    }
  },
  "DashboardCtrl": {
    "actionBtn": "Manage"
  },
  "PlansZero": {
    "title": "Plans",
    "description": [
      "Plans are divided into plan details seen below",
      "Plan detals are divided into features",
      "All plan  details are cumulative in pricing"
    ],
    "marketingServices": {
      "services": {
        "title": "Market Your Brand",
        "sections": [
          [
            [
              "Automate Social Media Posting"
            ],
            [
              "Contact Us"
            ]
          ],
          [
            [
              "Post Content on multiple social media sites 30 times per month"
            ],
            [
              "See Details Below"
            ]
          ]
        ]
      },
      "automateSocialMedia": {
        "title": "Automate Your Social Media",
        "sections": [
          [
            [
              "Posting"
            ],
            [
              "30x a month on 10 platforms",
              "60x a month on 10 platforms",
              "90x a month on 10 platforms",
              "30x a month on 20 platforms",
              "60x a month on 20 platforms",
              "90x a month on 20 platforms",
              "more"
            ],
            [
              "$100",
              "$200",
              "$300",
              "$400",
              "$500",
              "$600",
              "contact us"
            ]
          ]
        ]
      }
    },
    "videoEditing": {
      "tools": {
        "title": "Tools",
        "sections": [
          [
            [
              "Davinci Resolve 18"
            ]
          ]
        ]
      },
      "services": {
        "title": "Video Editing",
        "sections": [
          [
            [
              "Basic Video editing"
            ],
            [
              "Removing filler",
              "Trimming Video Gaps"
            ],
            [
              "30 mins - 4 hrs"
            ],
            [
              "$10 - $20/hr"
            ]
          ],
          [
            [
              "Intermediate Video editing"
            ],
            [
              "Editing in footage",
              "Editing in background music",
              "Editing in voiceover",
              "Editing in sound effects"
            ],
            [
              "1 hr - 5 days"
            ],
            [
              "$10 - $20/hr"
            ]
          ],
          [
            [
              "Advanced Video editing"
            ],
            [
              "Adding Transitions",
              "Adding in visual effects (sub-titles, social media)",
              "Volume Normalization",
              "Foundational Volume Mixing"
            ],
            [
              "2 hrs - 10 days"
            ],
            [
              "$10 - $20/hr"
            ]
          ]
        ]
      }
    },
    "appServices": {
      "services": {
        "title": "Build An Application",
        "sections": [
          [
            [
              "Web"
            ],
            [
              "See Details Below"
            ]
          ],
          [
            [
              "Mobile"
            ],
            [
              "See Details Below"
            ]
          ]
        ]
      },
      "free": {
        "title": "Free",
        "sections": [
          [
            [
              "Sentry"
            ],
            [
              "Monitoring",
              "Error Reporting"
            ],
            [
              "0 - 30mins"
            ],
            [
              "Free!"
            ]
          ],
          [
            [
              "User Account Deletion"
            ],
            [
              "Users can delete their own account"
            ],
            [
              "0 - 30mins"
            ],
            [
              "Free!"
            ]
          ],
          [
            [
              "Legal Assistance"
            ],
            [
              "Assist with Terms of Service",
              "Assist with Privacy Policy"
            ],
            [
              "30mins - 3hrs"
            ],
            [
              "Free!"
            ]
          ],
          [
            [
              "Desktop Navigation"
            ],
            [
              ""
            ],
            [
              "3hrs - 1 day"
            ],
            [
              "Free!"
            ]
          ]
        ]
      },
      "needs": {
        "title": "Necessities",
        "sections": [
          [
            [
              "Domain"
            ],
            [
              "purchase",
              "setup",
              "domain for email",
              "domain for other 3rd party etc"
            ],
            [
              "1hr - 5hrs"
            ],
            [
              "$3 - $5"
            ]
          ],
          [
            [
              "Hosting (Select)"
            ],
            [
              "Hosting Service",
              "SSL Certificate"
            ],
            [
              "1hr - 5hrs"
            ],
            [
              "$3 - $5"
            ]
          ]
        ]
      },
      "pages": {
        "title": "Pages",
        "sections": [
          [
            [
              "Page Amnt"
            ],
            [
              "1 - 5",
              "6 - 9",
              "9+"
            ],
            [
              "5hrs - 3 days",
              "3 days - 2weeks",
              "Contact Us"
            ],
            [
              "$3 - $5",
              "$5 - $9",
              "$10 - 15"
            ]
          ],
          [
            [
              "Page Type"
            ]
          ],
          [
            [
              "Legal"
            ],
            [
              "Privacy Policy",
              "Terms Of Service",
              "Manage Your Data"
            ],
            [
              "3hrs - 5 days"
            ],
            [
              "$5 - $7"
            ]
          ],
          [
            [
              "Content"
            ],
            [
              "landing",
              "about",
              "footer"
            ],
            [
              "3hrs - 2 days",
              "1hr - 4hrs"
            ],
            [
              "$3 - $5"
            ]
          ],
          [
            [
              "Communication"
            ],
            [
              "waitlist",
              "contact us",
              "survey",
              "chat"
            ],
            [
              "5hrs - 5 days",
              "3hrs - 2 days",
              "3days 2 weeks"
            ],
            [
              "$5 - $9"
            ]
          ],
          [
            [
              "Internal Data Source"
            ],
            [
              "Non-changing internal source",
              "Changing Internal Source(blog, ratings)"
            ],
            [
              "4hr - 2days",
              "3days - 3weeks"
            ],
            [
              "$3 - $8",
              "$15 - 20"
            ]
          ],
          [
            [
              "Ecommerce"
            ],
            [
              "events",
              "merchandise",
              "courses"
            ],
            [
              "4hr - 3days",
              "2 weeks - 2 months",
              "2 weeks - 2 months"
            ],
            [
              "$10 - $15",
              "$18 - 25"
            ]
          ]
        ]
      },
      "forms": {
        "title": "Forms",
        "sections": [
          [
            [
              "Amount of Fields"
            ],
            [
              "1 - 5",
              "6 - 9",
              "9+"
            ],
            [
              "1hr - 4hr",
              "3hrs - 2days",
              "3hrs - Contact Us"
            ],
            [
              "$3 - $5",
              "$5 - $9",
              "$10 - 15"
            ]
          ],
          [
            [
              "Field Type"
            ],
            [
              "Text Input",
              "Options",
              "Advanced Fields"
            ],
            [
              "N/A",
              "N/A - 2 weeks ~ complexity"
            ],
            [
              "$3 - $5",
              "$5 - $9",
              "$15 - 20"
            ]
          ],
          [
            [
              "Form Pages"
            ],
            [
              "1",
              "2+"
            ],
            [
              "2hrs - 5hrs",
              "2days - 2weeks "
            ],
            [
              "$3 - $5",
              "$10 - 20"
            ]
          ]
        ]
      },
      "account": {
        "title": "Accounts",
        "sections": [
          [
            [
              "Amount of Account Properties"
            ],
            [
              "1-3",
              "3+"
            ],
            [
              "1hr - 2days",
              "5hrs - Contact Us"
            ],
            [
              "$5 - $10",
              "Contact Us"
            ]
          ],
          [
            [
              "Profile Property Categories"
            ]
          ],
          [
            [
              "Auth"
            ],
            [
              "username/password",
              "social IDP (Facebook, Google ... sign-in)"
            ],
            [
              "5hr - 2days"
            ],
            [
              "$4 - $8"
            ]
          ],
          [
            [
              "Address Info"
            ],
            [
              "Street Address",
              "Apt/Unit/Suite",
              "City",
              "State",
              "Zipcode/Postal Code",
              "Country"
            ],
            [
              "5hr - 2days"
            ],
            [
              "$7 - $13"
            ]
          ],
          [
            [
              "Billing Info"
            ],
            [
              "Methods of Payment",
              "Subscriptions"
            ],
            [
              "3 days - 3 weeks"
            ],
            [
              "$7 - $13"
            ]
          ],
          [
            [
              "Merchandise Info"
            ],
            [
              "Orders",
              "Shopping Carts"
            ],
            [
              "3 days - 3 weeks"
            ],
            [
              "$7 - $13"
            ]
          ],
          [
            [
              "Social Media Info"
            ],
            [
              "Posts",
              "Articles",
              "Comments",
              "Interactions",
              "Friends"
            ],
            [
              "5hrs - 3 weeks",
              "2hrs - 2 weeks"
            ],
            [
              "$10 - $17",
              "$5 - $12"
            ]
          ],
          [
            [
              "Content Info"
            ],
            [
              "Files",
              "Images",
              "Videos",
              "Other Media Types"
            ],
            [
              "1 day - 2 weeks",
              "3days - 2 weeks"
            ],
            [
              "$5 - $12",
              "$8 - $12"
            ]
          ],
          [
            [
              "Notification Info"
            ],
            [
              "Email",
              "Push",
              "Preferences",
              "SMS"
            ],
            [
              "2 days - 2 weeks",
              "2 weeks - 2 months"
            ],
            [
              "$7 - $15",
              "Contact Us"
            ]
          ],
          [
            [
              "Account Mangement"
            ],
            [
              "Delete Your Data",
              "Export Your Data( 1 -5 properties )",
              "Export Your Data( 6 - 8 properties)",
              "Export Your Data( 8 + properties )"
            ],
            [
              "1 day - 1 week",
              "1 days - 3 days",
              "1 days - 4 days",
              "2 days - Contact Us"
            ],
            [
              "Free",
              "$3 - $5",
              "$3 - $7",
              "$8 - $12"
            ]
          ]
        ]
      },
      "features": {
        "title": "Features",
        "sections": [
          [
            [
              "Navigation"
            ],
            [
              "desktop nav",
              "mobile nav"
            ],
            [
              "3hrs - 1day"
            ],
            [
              "Free",
              "$3-$5"
            ]
          ],
          [
            [
              "Search"
            ],
            [
              "Option Search",
              "Input Search "
            ],
            [
              "2 days - 5 days"
            ],
            [
              "$15 - $20",
              "$15 - Contact Us"
            ]
          ],
          [
            [
              "Misc"
            ],
            [
              "Made For All Devices (responsive)",
              "Color Contrast",
              "Site Language Translation"
            ],
            [
              "2 days - 1 week"
            ],
            [
              "$3 - $7"
            ]
          ],
          [
            [
              "Maps"
            ]
          ],
          [
            [
              "Map Type"
            ],
            [
              "Plain",
              "Decorated"
            ],
            [
              "5hrs - 1 day",
              "4days - Contact Us"
            ],
            [
              "$3 - $7",
              "$15 - $20"
            ]
          ],
          [
            [
              "Anount of Maps"
            ],
            [
              "1 - 2",
              "3 - 5",
              "5+"
            ],
            [
              "2hrs - 1 day",
              "1 day - 4 days",
              "Contact Us"
            ],
            [
              "$3 - $5",
              "$5 - $9"
            ]
          ],
          [
            [
              "Advanced Visual Graphics Features"
            ],
            [
              "Animations",
              "WebGL"
            ],
            [
              "2hrs - Contact Us",
              "2 days - Contact Us",
              "Contact Us"
            ],
            [
              "$4 - Contact Us",
              "$5 - Contact Us"
            ]
          ]
        ]
      }
    }
  },
  "SectionTwo": {
    "featureTitle": "Feature",
    "detailsTitle": "Details",
    "turnarondTitle": "Time",
    "priceTitle": "Hourly Rate",
    "tableDesc": "Feature, Turnaround and Pricing"
  },
  "AccountDashboardZero": {
    "Email": "Email :",
    "Phone": "Phone :",
    "Projects": "Projects: ",
    "coursesCompleted": "Completed Courses: ",
    "coursesStarted": "Started Courses: ",
    "courseTier": "Courses Tier: ",
    "merchOrders": "Orders: ",
    "billingInfo": {
      "rewardsPoints": "Rewards Points: ",
      "subscriptions": "Subscriptions: ",
      "paymentMethods": "Payment Methods: "
    }
  },
  "ConfirmDialogZero": {
    "title": "WARNING! This action cannot be undone. Are you sure you wish to proceed",
    "options": [
      "Yes",
      "No"
    ]
  },
  "CardOne": {
    "actionBtn": "View"
  },
  "AccountZero": {
    "userId": "Your User ID: ",
    "accountCreated": "Account Creation Date :",
    "lastSignIn": "Last Sign In :",
    "navOptions": [
      "Dashobard",
      "Profile",
      "Merch",
      "Courses",
      "Projects",
      "Billing Info",
      "Manage Your Data"
    ],
    "viewAcctSectionBtn": "View",
    "menuCards": [
      {
        "title": "Profile"
      },
      {
        "title": "Client Portal"
      },
      {
        "title": "Billing Info"
      },
      {
        "title": "Courses"
      },
      {
        "title": "Merch"
      }
    ]
  },
  "VerifiedZero": {
    "button": "Verify",
    "msg": "Verified"
  },
  "AccountProjectsZero":{
    "searchInput":"Search",
    "type":"Type",
    "creationDate":"Creation Date",
    "url":"Board Preview",
    "noProjects":"You have no projects, Please schedule a time on our calendly if you would like to start a new project",
    "contactUsBtn":"Contact Us"
  },
  "AccountProfileZero": {
    "updateBtn": "Update",
    "profile": {
      "title": "Profile"
    },
    "notify": {
      "title": "Notifications"
    },
    "mainForm": {
      "displayNameField": {
        "label": "Display Name",
        "error": {}
      },
      "emailField": {
        "label": "Email",
        "error": {}
      },
      "emailVerifiedField": {
        "label": "Email Verified",
        "error": {}
      },
      "phoneNumberField": {
        "label": "Phone: (US Only)",
        "error": {}
      }
    },
    "notifyForm": {
      "emailMarketingConsentField": {
        "label": "Email Notifications",
        "error": {}
      },
      "smsMarketingConsentField": {
        "label": "SMS Notifications",
        "error": {}
      }
    }
  },
  "AccountBillingZero": {
    "deleteCardBtn": "Delete Card",
    "noPaymentMethods": "Add A Payment Method",
    "paymentMethodsTitle": "Payment Methods",
    "paymentMethodsAddBtn": "Add",
    "paymentMethodsAddCardBtn": "Add Card",
    "addressTitle": "Address",
    "addressAction": "Edit",
    "wmlNotify": {
      "noCardsAvailableToDelete": "There are no cards available to delete as of right now",
      "cardInvalidForm": "Please fill out all payment details appropriately",
      "cardAddedSuccess": "Card Added Sucessfully"
    },
    "addressForm": {
      "streetAdrField": {
        "label": "Street Address",
        "placeholder": "Enter your Street Address",
        "error": {
          "required": "Street Address is required"
        }
      },
      "secondaryAdrField": {
        "label": "Unit, Apt., Ste., etc.",
        "placeholder": "Enter your Unit, Apt., Ste., etc.",
        "error": {
          "required": "Unit, Apt., Ste., etc. is required"
        }
      },
      "cityField": {
        "label": "City",
        "placeholder": "Enter your City",
        "error": {
          "required": "City is required",
          "email": "Please provide the email in the correct format"
        }
      },
      "stateField": {
        "label": "State",
        "placeholder": "Enter your State",
        "error": {
          "required": "State is required"
        }
      },
      "zipcodeField": {
        "label": "Zipcode",
        "placeholder": "Enter your Zipcode",
        "error": {
          "required": "Zipcode is required"
        }
      },
      "countryField": {
        "label": "Country",
        "placeholder": "Enter your Country",
        "error": {
          "required": "Country is required"
        }
      }
    },
    "creditCardForm": {
      "cardNumberField": {
        "label": "Card Number",
        "error": {
          "creditCard": "Please enter a valid credit card number"
        }
      },
      "expiryDateField": {
        "label": "Expiry Date",
        "error": {
          "invalidMonth": "This is an invalid Month",
          "invalidYear": "This is an invalid Year"
        }
      },
      "securityCodeField": {
        "label": "Security Code",
        "error": {}
      }
    }
  },
  "AccountManageYourDataZero": {
    "export": {
      "title": "Export Your Data",
      "desc": "Easily access and manage your personal content with our \"Export Your Data\" feature. Your data will be available for download in JSON format, providing a structured snapshot of your interactions."
    },
    "delete": {
      "title": "Delete Your Data",
      "desc": "The Delete Your Data option puts you in charge of your information. Permanently remove your content from our platform and systems, prioritizing your privacy and preferences."
    },
    "wmlNotify": {
      "accountDeletedSuccess": "Account deleted sucessfully"
    }
  },
  "CardTwo": {
    "cardProviderImgAlt": "Card Provider Logo",
    "cardNumber": "CARD NUMBER",
    "expiration": "EXPIRATION"
  },
  "AccountsService": {
    "donate0": "Donate",
    "signUp0": "Sign Up",
    "login0": "Log In",
    "logout0": "Log Out",
    "profileBtn0": "Profile",
    "profileURLAlt": "Profile Image",
    "wmlNotify": {
      "corruptedAccount": "It seems an account was created for you but it is corrupted, Please try again later or contact customer support for asistance, if the error continues, please refer to our legal section to export and delete your data and create a new account",
      "loggedOutSuccess": "Logged out sucessfully",
      "loggedOutError": "There was an error while trying to log out please try again later or contact support if the issue persists"
    }
  },
  "nav": {
    "pageTitle": {
      "default": "WindMillCode",
      "contact": "WindMillCode Contact",
      "about": "WindMillCode About",
      "store": "WindMillCode Store",
      "account": "WindMillCode Account",
      "blog":"Windmillcode Blog",
      "online": "Windmillcode Online Events",
      "in-person":"Windmillcode In-Person Events",
      "plans":"Windmillcode Plans",
      "products":"Windmillcode Products",
      "projects":"Windmillcode Projects",
      "sign-up":"Windmillcode Sign Up",
      "sign-in":"Windmillcode Log In",
      "product-details":"Windmillcode Product Details",
      "checkout":"Windmillcode Checkout",
      "legal":"Windmillcode Legal",
      "labs":"Windmillcode Labs"
    }
  },
  "siteOffine": {
    "title": "Site Offline",
    "subtitle": "The site is currently unavailable due to scheduled maintenance, Please try again later"
  },
  "notFound": {
    "lines": [
      "404",
      "Whoops! This is not what you were looking for",
      "But you just found the resume we'd lost, thanks. Try your luck by going back to the ",
      "home page."
    ],
    "someImgAlt": "Resume"
  },
  "app": {},
  "NavZero": {
    "title": "WindMillCode",
    "lightMode": "Light Mode",
    "darkMode": "Dark Mode",
    "mainOptions": [
      [
        "Home"
      ],
      [
        "About"
      ],
      [
        "Projects"
      ],
      [
        "Media",
        [
          "Blog",
          "Events",
          [
            "Online",
            "In-Person"
          ],
          "Labs"
        ]
      ],
      [
        "Courses"
      ],
      [
        "Pricing",
        [
          "Plans",
          "Store",
          [
            "Products",
            "Cart",
            "Checkout"
          ],
          "Donate"
        ]
      ],
      [
        "Account",
        [
          "Dashboard",
          "Profile",
          "Billing",
          "Your Data"
        ]
      ],
      [
        "Contact Us"
      ]
    ]
  },
  "FooterZero": {
    "allRights": " WindmillCode, All Rights Reserved",
    "logoImgAlt": "Logo Img",
    "logoSection": {
      "text": "Building out all the features that your business needs to thrive"
    },
    "quickLinks": {
      "title": "Quick Links",
      "items": [
        "Donate",
        "About",
        "Pricing Plans",
        "Store",
        "Contact Us"
      ]
    },
    "legal": {
      "title": "Legal",
      "items": [
        "Privacy Policy",
        "Terms and Conditions"
      ]
    },
    "languages": {
      "title": "Languages",
      "items": [
        "English",
        "Chinese",
        "Spanish",
        "Hindi",
        "Ukrainian",
        "Arabic",
        "Bengali",
        "Malay",
        "French",
        "German",
        "Swahili",
        "Amharic"
      ]
    },
    "socialMedia": {
      "title": "Follow Us",
      "socialIconsAlt": [
        "The Black Tube",
        "Facebook",
        "Twitter",
        "Instagram",
        "Patreon",
        "Tik tok",
        "Discord",
        "Slack",
        "Pinterest",
        "Tumblr",
        "Reddit",
        "Twitch"
      ]
    }
  },
  "HomeMain": {
    "title": "Transform your idea into reality",
    "info": "Here at WindmillCode, our day to day operations is with a focus on the customer in mind.  We leverage many tools to create applications for several industries, including blockchain, career coaching and AI. What sets us apart is our ability to quickly assess your business needs and apply our previous infrastructure and development experience to deliver solutions that gets your project off to a viable first start. So if you are looking for an organization that is eager to take on new challenges, apply their expertise, and deliver results that exceed expectations, then look no further. Contact us today! "
  },
  "ContactUsForm": {
    "mainForm": {
      "title": "Upload resume or job role description for new results",
      "notify": "Not required unless you want to upload new resume",
      "nameField": {
        "label": "Name",
        "placeholder": "Your Name Here",
        "error": {
          "required": "A job description is required"
        }
      },
      "companyField": {
        "label": "Company",
        "placeholder": "company name",
        "error": {
          "required": "A job description is required"
        }
      },
      "emailField": {
        "label": "Email",
        "placeholder": "company email",
        "error": {
          "required": "An email is required",
          "email": "Please provide the email in the correct format"
        }
      },
      "phoneField": {
        "label": "Phone",
        "placeholder": "phone",
        "error": {}
      },
      "descField": {
        "label": "Description",
        "placeholder": "How can we best help?",
        "error": {
          "required": "A description is required"
        }
      }
    }
  },
  "ContactMain": {
    "title": "Contact Us",
    "or":"Or"
  },
  "CardZero": {
    "wmlNotify": {
      "missingArticleLink": "The link to this article is not available as of right now"
    },
    "googlePlayStore":{
      "imgAlt":"Google Play Store Badge Link"
    },
    "appleAppStore":{
      "imgAlt":"Apple App Store Badge Link"
    },
    "webBrowser":{
      "imgAlt":"Website Badge Link"
    }
  },
  "EntityMain": {
    "blog": {
      "title": "Blog",
      "imgAlt": "Blog Thumbnail"
    },
    "onlineEvents": {
      "title": "Online Events",
      "imgAlt": "Event Thumbnail"
    },
    "inPersonEvents": {
      "title": "In-Person Events",
      "imgAlt": "Event Thumbnail"
    },
    "labs": {
      "title": "Labs",
      "imgAlt": "Lab Thumbnail"
    },
    "articleImgAlt": "Article Img",
    "wmlNotify": {
      "noRecords": "There are no records right now please try again later or contact support if the issue persists"
    }
  },
  "EventsPanelItem": {
    "navigateToSiteBtn": "Navigate To Event"
  },
  "AboutMain": {
    "sections": [
      {
        "title": "Mission",
        "text": "We have adapted the common tech-friendly sentiment of “making the world a better place,” but they have incorporated their own unique spin on this value by turning its focus toward their product. While this mission statement might be vague, they narrow their focus just enough to make their mission statement feel personalized to their company."
      },
      {
        "title": "Values",
        "text": "WindMillCode's culture is driven by respect, transparency, collaboration and direct feedback.  We’re strive to communicate with our users as well as within the team. We love lean, iterative improvements, and success is measured by the value we create for our users. Here at Windmillcode we believe in in a core set of techonologies as we create template of new features coming from the everyday modern world, we are able to complete the next project faster than the last."
      },
      {
        "title": "Vision",
        "text": "WindMillCode's is a technology company whose mission is to empower every person and every organization on the planet to achieve more. We strive to create local opportunity, growth, and impact in everything we do . Our strategy is to build best-in-class platforms and productivity to create applications the meets all the targets and goals of the end client"
      }
    ]
  },
  "ProjectsZero":{
    "title":"Our Projects",
    "sections":{
      "apps":{
        "title":"Web And Mobile Apps",
        "imgAlt":"Project Thumbnail",
        "projects":[
          {
            "title":"Eneobia",
            "desc":"Video Management Platform App where users can transfer, upload, and download videos between their computer and multple video platform apps"
          },
          {
            "title":"Find My Role",
            "desc":"AI powered resume app where users can upload a resume and JD and receive best tips on what to talk about during a potential interview"
          },
          {
            "title":"Proof of Vibes",
            "desc":"Social  Blockchain  Engineering Projects where users create NFT's souvenirs from events. Created with React, Firebase Auth, Firebase Realtime Database, NEAR Blockchain Technologies, SCSS,Material/UI, and Python"
          },
          {
            "title":"Zawadi ya Manukato",
            "desc":"Restaurant application where users can place orders for food to the restaurant and have food prepared for them (in progress)"
          },
          {
            "title":"WaveRide",
            "desc":"A community app for surfers and skaters. Users interact with it in several ways including communicating with other users, receiving alerts about cautions in the area, viewing events and locations and receiving the most update to news in their newsfeed"
          },
          {
            "title":"Wave and Grind",
            "desc":"Exclusive division of the WaveRide collection where surfers and skaters join a waitlist to wait for exclusive goods to drop. Once the items drop waitlist members typically have about 24 hours to access. Password to access is mercury"
          }
        ]
      },
      "browserExtensions":{
        "title":"Browser Extensions",
        "imgAlt":"Browser Extensions Thumbnail",
        "projects":[
          {
            "title":"AI Prompt Modifier",
            "desc":"The AI Prompt Modifier Extension enhances your ChatGPT experience by allowing you to easily customize your prompts with prefixes and suffixes. Users can manage groups of modifications, import/export their settings, and apply changes to their prompts with a single click. This extension streamlines interactions, boosts productivity, and provides a user-friendly interface for seamless customization."
          },
          {
            "title":"Convert From Blue",
            "desc":"Convert From Blue is a browser extension that automatically converts most blue colors on websites to eye-friendly shades of orange, reducing eye strain, improving sleep, and enhancing browsing comfort, with features like customizable settings, real-time conversion, gradient support, and video filtering, while recognizing limitations related to browser and site restrictions."
          },
          {
            "title":"Replace Shopify Email Variables",
            "desc":"Replace Shopify Email Variables is a browser extension that automates the replacement of Shopify email variables, allowing you to easily update store URLs, forgot password links, account URLs, and store text, with an intuitive interface, automation features, and customization options to save time and reduce errors, ensuring a seamless customer experience."
          }
        ]
      },
      "vscodeExtensions":{
        "title":"Vscode Extensions",
        "imgAlt":"Vscode Extensions Thumbnail",
        "projects":[
          {
            "title":"Open Related Files",
            "desc":"Windmillcode Open Related Files is a VSCode extension designed to simplify file management by allowing you to seamlessly switch between related files in your project using custom configurations in `settings.json`. It automates the opening of related files based on your defined file patterns, regex predicates, and layout preferences, helping developers efficiently manage and navigate their codebase without getting overwhelmed by file handling."
          },
          {
            "title":"Tasks Zero",
            "desc":"Windmillcode Tasks Zero is a versatile extension that helps automate various development tasks, providing commands for Angular, Docker, Flask, Flutter, Firebase, Git, Python, SQL, TestNG, and NPM, saving you time by allowing you to run tasks like building, testing, and updating projects with ease, all from a single interface tailored to meet your specific development needs."
          },
          {
            "title":"Snippets Zero",
            "desc":"Windmillcode Snippets Zero is a development tool that provides SCSS and CSS snippets to streamline coding tasks that are too small for full scripts but too repetitive for manual typing, offering snippets for component styles, loops, importing global styles, numbering conventions, em conversions, color variables, @font-face with Base64 and URL, and WML spacing to help make your day-to-day development more efficient and consistent."
          },
          {
            "title":"Paste Text From Image",
            "desc":"The extension simplifies the process of extracting text from images, screenshots, or other visual content, allowing you to seamlessly paste the extracted text directly into your VSCode editor. Whether you need text from an image for coding, documentation, or other purposes, this tool streamlines the task, enhancing your productivity."
          },
          {
            "title":"LibTracker",
            "desc":"LibTracker is a simple SBOM tool designed to streamline dependency management across projects, allowing users to view, organize, and monitor project dependencies, including frameworks, programming languages, licenses, and security vulnerabilities. Easily integrate with VSCode for CRUD operations, terminal access, and workspace management, supporting popular platforms like Node.js, Java, Python, Ruby, and C#."
          },
          {
            "title":"Orange Text Theme",
            "desc":"Orange Text Theme applies orange and amber tones to VSCode text elements for a visually appealing interface. The theme prioritizes eye comfort, reducing strain during long coding sessions. Its warm colors provide a better contrast compared to default themes. This makes it a great choice for developers seeking a stylish yet functional appearance."
          }
        ]
      },
      "jsLibraries":{
        "title":"JS Packages & Plugins",
        "imgAlt":"JS Packages Thumbnail",
        "projects":[
          {
            "title":"Windmillcode CDK",
            "desc":"Windmillcode CDK is a comprehensive suite of reusable Angular components designed to simplify and enhance web application development, offering React-like props and plug-and-play functionality, customizable and themable UI elements, i18n support, and regular updates aligned with Angular versions, making it a powerful tool for developers building engaging, robust, and user-friendly applications."
          },
          {
            "title":"Quill Emoji",
            "desc":"Windmillcode Quill Emoji Selector is a Quill.js module extension that integrates emoji functionality into the editor via toolbar or emoji code, built for Quill 2.0.0, with plans for continuous updates to match Quill versions; contributions are welcome to improve shorthand functionality, tree-shakability, and add tests, while customization options allow for custom emoji blots, lists, and toolbar icons."
          },
          {
            "title":"Karma Microsoft Edge Launcher",
            "desc":"a Karma plugin that allows you to launch Microsoft Edge for testing in a Karma environment with minimal configuration; simply add the plugin to your Karma config file, include 'Edge' in the browsers list, and you're ready to go."
          }
        ]
      },
      "otherLibraries":{
        "title":"Other Packages & Plugins",
        "imgAlt":"Misc Packages Thumbnail",
        "projects":[
          {
            "title":"Python: Ai Model Managers ",
            "desc":"WML AI Model Managers is a PyTorch-based package that provides a collection of AI classes designed to simplify the process of training, managing, and interacting with AI models. It offers functionality for downloading datasets, training models, saving them as pickle files, and interacting with trained models for chatbot applications, all while allowing customization of various model parameters like embeddings, layers, batch size, and more, with continuous updates and bug fixes to improve usability and performance."
          },
          {
            "title":"Flutter: Flutter Translate",
            "desc":"Windmillcode Flutter Translate is a versatile localization and internationalization (i18n) library for Flutter, compatible with mobile, web, and desktop platforms. It supports pluralization, nested JSON structures, automatic locale management, and right-to-left locales, making it easy to switch between languages. The library is highly customizable, offering support for both inline and nested JSON files, with detailed documentation and examples available."
          },
          {
            "title":"Flutter: Peerdart",
            "desc":"Windmillcode PeerDart is a simple and configurable peer-to-peer API built on top of WebRTC, designed for Flutter. It supports data channels and socket.io connections, enabling peer-to-peer communication for various platforms, including Android, iOS, Linux, macOS, and Windows. PeerDart is based on PeerJS and is currently in public alpha, with media stream support planned for future versions. It allows you to create secure peer connections and transfer data seamlessly using Dart."
          },
          {
            "title":"Golang: CLI Scripts",
            "desc":"The go_cli_scripts package provides a versatile collection of Go utility functions aimed at simplifying common tasks, including array manipulation, async processing, file and directory handling, Docker and Git operations, JSON formatting, map conversions, menu creation, string manipulation, TestNG test execution, and VSCode settings management, making it suitable for a wide range of applications from basic file tasks to more complex asynchronous processes and API interactions."
          }
        ]
      }
    }
  },
  "StoreService": {
    "addToCartBtn": "Add To Cart",
    "buyNowBtn": "Buy Now",
    "merchAlt": "Windmillcode Merch",
    "wmlNotify": {
      "squarePayments": "There was an issue while connecting to our payments service. Please try again later or contact support if the issue persists"
    }
  },
  "PanelCartContainer": {
    "addCartBtn": "Add Cart",
    "removeCartBtn": "Remove Cart",
    "tabHeader": "Cart",
    "currentCart": "Current Cart :"
  },
  "PanelCart": {
    "color": "Color",
    "size": "Size",
    "quantity": "Quantity",
    "price": "Price",
    "totalPrice": "Total Price",
    "buyNowBtn": "Proceed To Checkout",
    "removeItemBtn": "Remove Item"
  },
  "CheckoutZero": {
    "wmlNotify": {
      "noItemsInCart": "There are currently no items in your cart, add items to your cart first"
    },
    "makePurchase": "Place Order",
    "makePurchaseInfoText": "You will be redirected to shopify in order to complete your purchase"
  },
  "OrderConfirmed": {
    "title": "Order Sucessfully Placed!",
    "yourConfimation0": "Your Order ID is  :",
    "yourConfimation1": "Please keep the order ID for your records"
  },
  "PrivacyPolicy": {
    "title": "Privacy Policy",
    "sections": [
      "Protecting your private information is our priority. This Statement of Privacy applies to Windmillcode for collection and usage. For the purposes of this Privacy Policy, unless otherwise noted references to Windmillcode include https://https://windmillcode.com. The Windmillcode website is a consulting application. By using the Windmillcode website, you consent to the data practices described in this statement.",
      "Collection of your Personal Information",
      "In order to better provide you with products and services offered, Windmillcode may collect personally identifiable information, such as your:",
      [
        "- First and Last Name",
        "- Mailing Address",
        "- E-mail Address",
        "- Phone Number",
        "- Location"
      ],
      "We do not collect any personal information about you unless you voluntarily provide it to us. However, you may be required to provide certain personal information to us when you elect to use certain products or services. These may include:",
      [
        "(a) registering for an account;",
        "(b) entering a sweepstakes or contest sponsored by us or one of our partners;",
        "(c) signing up for special offers from selected third parties;",
        "(d) sending us an email message;",
        "(e) submitting your credit card or other payment information when ordering and purchasing products and services"
      ],
      "We will use your information for, but not limited to, communicating with you in relation to services and/or products you have requested from us. We also may gather additional personal or non-personal information in the future.",
      "Use of your Personal Information ",
      "Windmillcode collects and uses your personal information to operate and deliver the services you have requested.",
      "Windmillcode may also use your personally identifiable information to inform you of other products or services available from Windmillcode and its affiliates.",
      "Sharing Information with Third Parties",
      "Windmillcode does not sell, rent or lease its customer lists to third parties.",
      "Windmillcode may share data with trusted partners to help perform statistical analysis, send you email or postal mail, provide customer support, or arrange for deliveries. All such third parties are prohibited from using your personal information except to provide these services to Windmillcode, and they are required to maintain the confidentiality of your information. ",
      "Windmillcode may disclose your personal information, without notice, if required to do so by law or in the good faith belief that such action is necessary to: (a) conform to the edicts of the law or comply with legal process served on Windmillcode or the site; (b) protect and defend the rights or property of Windmillcode; and/or (c) act under exigent circumstances to protect the personal safety of users of Windmillcode, or the public. ",
      "Security of your Personal Information",
      "Windmillcode secures your personal information from unauthorized access, use, or disclosure. Windmillcode uses the following methods for this purpose: ",
      [
        "- Social sign in",
        "- HTTPS encrpytion",
        "- leverging account management mechanisms from major cloud providers"
      ],
      "We strive to take appropriate security measures to protect against unauthorized access to or alteration of your personal information. Unfortunately, no data transmission over the Internet or any wireless network can be guaranteed to be 100% secure. As a result, while we strive to protect your personal information, you acknowledge that: (a) there are security and privacy limitations inherent to the Internet which are beyond our control; and (b) security, integrity, and privacy of any and all information and data exchanged between you and us through this Site cannot be guaranteed. ",
      "Right to Deletion",
      "Subject to certain exceptions set out below, on receipt of a verifiable request from you, we will: ",
      [
        "• Delete your personal information from our records; and",
        "• Direct any service providers to delete your personal information from their records."
      ],
      "Please note that we may not be able to comply with requests to delete your personal information if it is necessary to: ",
      [
        "• Complete the transaction for which the personal information was collected, fulfill the terms of a written warranty or product recall conducted in accordance with federal law, provide a good or service requested by you, or reasonably anticipated within the context of our ongoing business relationship with you, or otherwise perform a contract between you and us; ",
        "• Detect security incidents, protect against malicious, deceptive, fraudulent, or illegal activity; or prosecute those responsible for that activity;",
        "• Debug to identify and repair errors that impair existing intended functionality;",
        "• Exercise free speech, ensure the right of another consumer to exercise his or her right of free speech, or exercise another right provided for by law; ",
        "• Comply with the California Electronic Communications Privacy Act;",
        "• Engage in public or peer-reviewed scientific, historical, or statistical research in the public interest that adheres to all other applicable ethics and privacy laws, when our deletion of the information is likely to render impossible or seriously impair the achievement of such research, provided we have obtained your informed consent",
        "• Enable solely internal uses that are reasonably aligned with your expectations based on your relationship with us;",
        "• Comply with an existing legal obligation; or",
        "• Otherwise use your personal information, internally, in a lawful manner that is compatible with the context in which you provided the information"
      ],
      "Children Under Thirteen",
      "Windmillcode collects personally identifiable information from children under the age of thirteen. Windmillcode collects this information for the following reason(s): educational content ",
      "We provide information about our personal data practices for children on our home page and wherever we knowingly collect personal data from children on our application. If you are under the age of thirteen, you must ask your parent or guardian for permission to use this application. If you are a parent and you have questions regarding our data collection practices, please contact us using the information provided at the end of this Statement of Privacy. ",
      "Disconnecting your Windmillcode Account from Third Party Websites",
      "You will be able to connect your Windmillcode account to third party accounts. BY CONNECTING YOUR Windmillcode ACCOUNT TO YOUR THIRD PARTY ACCOUNT, YOU ACKNOWLEDGE AND AGREE THAT YOU ARE CONSENTING TO THE CONTINUOUS RELEASE OF INFORMATION ABOUT YOU TO OTHERS (IN ACCORDANCE WITH YOUR PRIVACY SETTINGS ON THOSE THIRD PARTY SITES). IF YOU DO NOT WANT INFORMATION ABOUT YOU, INCLUDING PERSONALLY IDENTIFYING INFORMATION, TO BE SHARED IN THIS MANNER, DO NOT USE THIS FEATURE. You may disconnect your account from a third party account at any time. Users may learn how to disconnect their accounts from third-party websites by visiting their \"My Account\" page on the connected parties site.  ",
      "E-mail Communications",
      "From time to time, Windmillcode may contact you via email for the purpose of providing announcements, promotional offers, alerts, confirmations, surveys, and/or other general communication. In order to improve our Services, we may receive a notification when you open an email from Windmillcode or click on a link therein. ",
      "If you would like to stop receiving marketing or promotional communications via email from Windmillcode, you may opt out of such communications by clicking on the UNSUBSCRIBE button. ",
      "External Data Storage Sites",
      "We may store your data on servers provided by third party hosting vendors with whom we have contracted.",
      "Changes to this Statement",
      "Windmillcode reserves the right to change this Privacy Policy from time to time. We will notify you about significant changes in the way we treat personal information by sending a notice to the primary email address specified in your account, by placing a prominent notice on our application, and/or by updating any privacy information. Your continued use of the application and/or Services available after such modifications will constitute your: (a) acknowledgment of the modified Privacy Policy; and (b) agreement to abide and be bound by that Policy. ",
      "Contact Information",
      "Windmillcode welcomes your questions or comments regarding this Statement of Privacy. If you believe that Windmillcode has not adhered to this Statement, please contact Windmillcode at:",
      "Email Address: contact@windmillcode.com ",
      "Effective as of: Feb 13, 2024"
    ]
  },
  "TermsAndConditions": {
    "title": "Terms and Conditions",
    "sections": [
      "Last updated June 04, 2023",
      "AGREEMENT TO OUR LEGAL TERMS",
      "We are Windmillcode (\"Company,\" \"we,\" \"us,\" \"our\").",
      "We operate the website https://windmillcode.com (the \"Site\"), as well as any other related products and services that refer or link to these legal terms (the \"Legal Terms\") (collectively, the \"Services\").",
      "You can contact us by email at contact@windmillcode.com or by mail to __________, __________, __________.",
      "These Legal Terms constitute a legally binding agreement made between you, whether personally or on behalf of an entity (\"you\"), and Windmillcode, concerning your access to and use of the Services. You agree that by accessing the Services, you have read, understood, and agreed to be bound by all of these Legal Terms. IF YOU DO NOT AGREE WITH ALL OF THESE LEGAL TERMS, THEN YOU ARE EXPRESSLY PROHIBITED FROM USING THE SERVICES AND YOU MUST DISCONTINUE USE IMMEDIATELY.",
      "We will provide you with prior notice of any scheduled changes to the Services you are using. The modified Legal Terms will become effective upon posting or notifying you by contact@windmillcode.com, as stated in the email message. By continuing to use the Services after the effective date of any changes, you agree to be bound by the modified terms.",
      "The Services are intended for users who are at least 18 years old. Persons under the age of 18 are permitted to use the services under parental supervision",
      "We recommend that you print a copy of these Legal Terms for your records.",
      "1. OUR SERVICES",
      "The information provided when using the Services is not intended for distribution to or use by any person or entity in any jurisdiction or country where such distribution or use would be contrary to law or regulation or which would subject us to any registration requirement within such jurisdiction or country. Accordingly, those persons who choose to access the Services from other locations do so on their own initiative and are solely responsible for compliance with local laws, if and to the extent local laws are applicable.",
      "The Services are not tailored to comply with industry-specific regulations (Health Insurance Portability and Accountability Act (HIPAA), Federal Information Security Management Act (FISMA), etc.), so if your interactions would be subjected to such laws, you may not use the Services. You may not use the Services in a way that would violate the Gramm-Leach-Bliley Act (GLBA).",
      "2. INTELLECTUAL PROPERTY RIGHTS",
      "Our intellectual property",
      "We are the owner or the licensee of all intellectual property rights in our Services, including all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics in the Services (collectively, the \"Content\"), as well as the trademarks, service marks, and logos contained therein (the \"Marks\").",
      "Our Content and Marks are protected by copyright and trademark laws (and various other intellectual property rights and unfair competition laws) and treaties in the United States and around the world.",
      "The Content and Marks are provided in or through the Services \"AS IS\" for your personal, non-commercial use or internal business purpose only.",
      "Your use of our Services",
      "Subject to your compliance with these Legal Terms, including the \"PROHIBITED ACTIVITIES\" section below, we grant you a non-exclusive, non-transferable, revocable license to:",
      [
        "- access the Services;",
        "- download or print a copy of any portion of the Content to which you have properly gained access."
      ],
      "solely for your personal, non-commercial use or internal business purpose.",
      "Except as set out in this section or elsewhere in our Legal Terms, no part of the Services and no Content or Marks may be copied, reproduced, aggregated, republished, uploaded, posted, publicly displayed, encoded, translated, transmitted, distributed, sold, licensed, or otherwise exploited for any commercial purpose whatsoever, without our express prior written permission.",
      "If you wish to make any use of the Services, Content, or Marks other than as set out in this section or elsewhere in our Legal Terms, please address your request to: contact@windmillcode.com. If we ever grant you the permission to post, reproduce, or publicly display any part of our Services or Content, you must identify us as the owners or licensors of the Services, Content, or Marks and ensure that any copyright or proprietary notice appears or is visible on posting, reproducing, or displaying our Content.",
      "We reserve all rights not expressly granted to you in and to the Services, Content, and Marks.",
      "Any breach of these Intellectual Property Rights will constitute a material breach of our Legal Terms and your right to use our Services will terminate immediately.",
      "Your submissions and contributions",
      "Please review this section and the \"PROHIBITED ACTIVITIES\" section carefully prior to using our Services to understand the (a) rights you give us and (b) obligations you have when you post or upload any content through the Services.",
      "Submissions: By directly sending us any question, comment, suggestion, idea, feedback, or other information about the Services (\"Submissions\"), you agree to assign to us all intellectual property rights in such Submission. You agree that we shall own this Submission and be entitled to its unrestricted use and dissemination for any lawful purpose, commercial or otherwise, without acknowledgment or compensation to you.",
      "Contributions: The Services may invite you to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality during which you may create, submit, post, display, transmit, publish, distribute, or broadcast content and materials to us or through the Services, including but not limited to text, writings, video, audio, photographs, music, graphics, comments, reviews, rating suggestions, personal information, or other material (\"Contributions\"). Any Submission that is publicly posted shall also be treated as a Contribution.",
      "You understand that Contributions may be viewable by other users of the Services and possibly through third-party websites.",
      "When you post Contributions, you grant us a license (including use of your name, trademarks, and logos): By posting any Contributions, you grant us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to: use, copy, reproduce, distribute, sell, resell, publish, broadcast, retitle, store, publicly perform, publicly display, reformat, translate, excerpt (in whole or in part), and exploit your Contributions (including, without limitation, your image, name, and voice) for any purpose, commercial, advertising, or otherwise, to prepare derivative works of, or incorporate into other works, your Contributions, and to sublicense the licenses granted in this section. Our use and distribution may occur in any media formats and through any media channels.",
      "This license includes our use of your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images you provide.",
      "You are responsible for what you post or upload: By sending us Submissions and/or posting Contributions through any part of the Services or making Contributions accessible through the Services by linking your account through the Services to any of your social networking accounts, you:",
      [
        "- confirm that you have read and agree with our \"PROHIBITED ACTIVITIES\" and will not post, send, publish, upload, or transmit through the Services any Submission nor post any Contribution that is illegal, harassing, hateful, harmful, defamatory, obscene, bullying, abusive, discriminatory, threatening to any person or group, sexually explicit, false, inaccurate, deceitful, or misleading;",
        "- to the extent permissible by applicable law, waive any and all moral rights to any such Submission and/or Contribution;",
        "- warrant that any such Submission and/or Contributions are original to you or that you have the necessary rights and licenses to submit such Submissions and/or Contributions and that you have full authority to grant us the above-mentioned rights in relation to your Submissions and/or Contributions",
        "- warrant and represent that your Submissions and/or Contributions do not constitute confidential information."
      ],
      "You are solely responsible for your Submissions and/or Contributions and you expressly agree to reimburse us for any and all losses that we may suffer because of your breach of (a) this section, (b) any third party’s intellectual property rights, or (c) applicable law.",
      "We may remove or edit your Content: Although we have no obligation to monitor any Contributions, we shall have the right to remove or edit any Contributions at any time without notice if in our reasonable opinion we consider such Contributions harmful or in breach of these Legal Terms. If we remove or edit any such Contributions, we may also suspend or disable your account and report you to the authorities.",
      "Copyright infringement",
      "We respect the intellectual property rights of others. If you believe that any material available on or through the Services infringes upon any copyright you own or control, please immediately refer to the \"COPYRIGHT INFRINGEMENTS\" section below.",
      "3. USER REPRESENTATIONS",
      "By using the Services, you represent and warrant that: (1) all registration information you submit will be true, accurate, current, and complete; (2) you will maintain the accuracy of such information and promptly update such registration information as necessary; (3) you have the legal capacity and you agree to comply with these Legal Terms; (4) you are not a minor in the jurisdiction in which you reside; (5) you will not access the Services through automated or non-human means, whether through a bot, script or otherwise; (6) you will not use the Services for any illegal or unauthorized purpose; and (7) your use of the Services will not violate any applicable law or regulation.",
      "If you provide any information that is untrue, inaccurate, not current, or incomplete, we have the right to suspend or terminate your account and refuse any and all current or future use of the Services (or any portion thereof).",
      "4. USER REGISTRATION",
      "You may be required to register to use the Services. You agree to keep your password confidential and will be responsible for all use of your account and password. We reserve the right to remove, reclaim, or change a username you select if we determine, in our sole discretion, that such username is inappropriate, obscene, or otherwise objectionable.",
      "5. PRODUCTS",
      "We make every effort to display as accurately as possible the colors, features, specifications, and details of the products available on the Services. However, we do not guarantee that the colors, features, specifications, and details of the products will be accurate, complete, reliable, current, or free of other errors, and your electronic display may not accurately reflect the actual colors and details of the products. All products are subject to availability, and we cannot guarantee that items will be in stock. We reserve the right to discontinue any products at any time for any reason. Prices for all products are subject to change.",
      "6. PURCHASES AND PAYMENT",
      "We accept the following forms of payment:",
      [
        "- Visa",
        "- Mastercard",
        "- American Express",
        "- Discover"
      ],
      "You agree to provide current, complete, and accurate purchase and account information for all purchases made via the Services. You further agree to promptly update account and payment information, including email address, payment method, and payment card expiration date, so that we can complete your transactions and contact you as needed. Sales tax will be added to the price of purchases as deemed required by us. We may change prices at any time. All payments shall be in US dollars.",
      "You agree to pay all charges at the prices then in effect for your purchases and any applicable shipping fees, and you authorize us to charge your chosen payment provider for any such amounts upon placing your order. We reserve the right to correct any errors or mistakes in pricing, even if we have already requested or received payment.",
      "We reserve the right to refuse any order placed through the Services. We may, in our sole discretion, limit or cancel quantities purchased per person, per household, or per order. These restrictions may include orders placed by or under the same customer account, the same payment method, and/or orders that use the same billing or shipping address. We reserve the right to limit or prohibit orders that, in our sole judgment, appear to be placed by dealers, resellers, or distributors.",
      "7. RETURN/REFUNDS POLICY",
      "All sales are final and no refund will be issued.",
      "8. PROHIBITED ACTIVITIES",
      "You may not access or use the Services for any purpose other than that for which we make the Services available. The Services may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us.",
      "As a user of the Services, you agree not to:",
      [
        "- Systematically retrieve data or other content from the Services to create or compile, directly or indirectly, a collection, compilation, database, or directory without written permission from us.",
        "- Trick, defraud, or mislead us and other users, especially in any attempt to learn sensitive account information such as user passwords.",
        "- Circumvent, disable, or otherwise interfere with security-related features of the Services, including features that prevent or restrict the use or copying of any Content or enforce limitations on the use of the Services and/or the Content contained therein.",
        "- Disparage, tarnish, or otherwise harm, in our opinion, us and/or the Services.",
        "- Use any information obtained from the Services in order to harass, abuse, or harm another person.",
        "- Make improper use of our support services or submit false reports of abuse or misconduct.",
        "- Use the Services in a manner inconsistent with any applicable laws or regulations.",
        "- Engage in unauthorized framing of or linking to the Services.",
        "- Upload or transmit (or attempt to upload or to transmit) viruses, Trojan horses, or other material, including excessive use of capital letters and spamming (continuous posting of repetitive text), that interferes with any party’s uninterrupted use and enjoyment of the Services or modifies, impairs, disrupts, alters, or interferes with the use, features, functions, operation, or maintenance of the Services.",
        "- Engage in any automated use of the system, such as using scripts to send comments or messages, or using any data mining, robots, or similar data gathering and extraction tools.",
        "- Delete the copyright or other proprietary rights notice from any Content.",
        "- Attempt to impersonate another user or person or use the username of another user.",
        "- Upload or transmit (or attempt to upload or to transmit) any material that acts as a passive or active information collection or transmission mechanism, including without limitation, clear graphics interchange formats (\"gifs\"), 1×1 pixels, web bugs, cookies, or other similar devices (sometimes referred to as \"spyware\" or \"passive collection mechanisms\" or \"pcms\").",
        "- Interfere with, disrupt, or create an undue burden on the Services or the networks or services connected to the Services.",
        "- Harass, annoy, intimidate, or threaten any of our employees or agents engaged in providing any portion of the Services to you.",
        "- Attempt to bypass any measures of the Services designed to prevent or restrict access to the Services, or any portion of the Services.",
        "- Copy or adapt the Services' software, including but not limited to Flash, PHP, HTML, JavaScript, or other code.",
        "- Except as permitted by applicable law, decipher, decompile, disassemble, or reverse engineer any of the software comprising or in any way making up a part of the Services.",
        "- Except as may be the result of standard search engine or Internet browser usage, use, launch, develop, or distribute any automated system, including without limitation, any spider, robot, cheat utility, scraper, or offline reader that accesses the Services, or use or launch any unauthorized script or other software.",
        "- Use a buying agent or purchasing agent to make purchases on the Services.",
        "- Make any unauthorized use of the Services, including collecting usernames and/or email addresses of users by electronic or other means for the purpose of sending unsolicited email, or creating user accounts by automated means or under false pretenses.",
        "- Use the Services as part of any effort to compete with us or otherwise use the Services and/or the Content for any revenue-generating endeavor or commercial enterprise.",
        "- Use the Services to advertise or offer to sell goods and services.",
        "- Sell or otherwise transfer your profile."
      ],
      "9. USER GENERATED CONTRIBUTIONS",
      "The Services may invite you to chat, contribute to, or participate in blogs, message boards, online forums, and other functionality, and may provide you with the opportunity to create, submit, post, display, transmit, perform, publish, distribute, or broadcast content and materials to us or on the Services, including but not limited to text, writings, video, audio, photographs, graphics, comments, suggestions, or personal information or other material (collectively, \"Contributions\"). Contributions may be viewable by other users of the Services and through third-party websites. As such, any Contributions you transmit may be treated as non-confidential and non-proprietary. When you create or make available any Contributions, you thereby represent and warrant that:",
      [
        "- The creation, distribution, transmission, public display, or performance, and the accessing, downloading, or copying of your Contributions do not and will not infringe the proprietary rights, including but not limited to the copyright, patent, trademark, trade secret, or moral rights of any third party.",
        "- You are the creator and owner of or have the necessary licenses, rights, consents, releases, and permissions to use and to authorize us, the Services, and other users of the Services to use your Contributions in any manner contemplated by the Services and these Legal Terms.",
        "- You have the written consent, release, and/or permission of each and every identifiable individual person in your Contributions to use the name or likeness of each and every such identifiable individual person to enable inclusion and use of your Contributions in any manner contemplated by the Services and these Legal Terms.",
        "- Your Contributions are not false, inaccurate, or misleading.",
        "- Your Contributions are not unsolicited or unauthorized advertising, promotional materials, pyramid schemes, chain letters, spam, mass mailings, or other forms of solicitation.",
        "- Your Contributions are not obscene, lewd, lascivious, filthy, violent, harassing, libelous, slanderous, or otherwise objectionable (as determined by us).",
        "- Your Contributions do not ridicule, mock, disparage, intimidate, or abuse anyone.",
        "- Your Contributions are not used to harass or threaten (in the legal sense of those terms) any other person and to promote violence against a specific person or class of people.",
        "- Your Contributions do not violate any applicable law, regulation, or rule.",
        "- Your Contributions do not violate the privacy or publicity rights of any third party.",
        "- Your Contributions do not violate any applicable law concerning child pornography, or otherwise intended to protect the health or well-being of minors.",
        "- Your Contributions do not include any offensive comments that are connected to race, national origin, gender, sexual preference, or physical handicap.",
        "- Your Contributions do not otherwise violate, or link to material that violates, any provision of these Legal Terms, or any applicable law or regulation."
      ],
      "Any use of the Services in violation of the foregoing violates these Legal Terms and may result in, among other things, termination or suspension of your rights to use the Services.",
      "10. CONTRIBUTION LICENSE",
      "By posting your Contributions to any part of the Services or making Contributions accessible to the Services by linking your account from the Services to any of your social networking accounts, you automatically grant, and you represent and warrant that you have the right to grant, to us an unrestricted, unlimited, irrevocable, perpetual, non-exclusive, transferable, royalty-free, fully-paid, worldwide right, and license to host, use, copy, reproduce, disclose, sell, resell, publish, broadcast, retitle, archive, store, cache, publicly perform, publicly display, reformat, translate, transmit, excerpt (in whole or in part), and distribute such Contributions (including, without limitation, your image and voice) for any purpose, commercial, advertising, or otherwise, and to prepare derivative works of, or incorporate into other works, such Contributions, and grant and authorize sublicenses of the foregoing. The use and distribution may occur in any media formats and through any media channels.",
      "This license will apply to any form, media, or technology now known or hereafter developed, and includes our use of your name, company name, and franchise name, as applicable, and any of the trademarks, service marks, trade names, logos, and personal and commercial images you provide. You waive all moral rights in your Contributions, and you warrant that moral rights have not otherwise been asserted in your Contributions.",
      "We do not assert any ownership over your Contributions. You retain full ownership of all of your Contributions and any intellectual property rights or other proprietary rights associated with your Contributions. We are not liable for any statements or representations in your Contributions provided by you in any area on the Services. You are solely responsible for your Contributions to the Services and you expressly agree to exonerate us from any and all responsibility and to refrain from any legal action against us regarding your Contributions.",
      "We have the right, in our sole and absolute discretion, (1) to edit, redact, or otherwise change any Contributions; (2) to re-categorize any Contributions to place them in more appropriate locations on the Services; and (3) to pre-screen or delete any Contributions at any time and for any reason, without notice. We have no obligation to monitor your Contributions.",
      "11. GUIDELINES FOR REVIEWS",
      "We may provide you areas on the Services to leave reviews or ratings. When posting a review, you must comply with the following criteria: (1) you should have firsthand experience with the person/entity being reviewed; (2) your reviews should not contain offensive profanity, or abusive, racist, offensive, or hateful language; (3) your reviews should not contain discriminatory references based on religion, race, gender, national origin, age, marital status, sexual orientation, or disability; (4) your reviews should not contain references to illegal activity; (5) you should not be affiliated with competitors if posting negative reviews; (6) you should not make any conclusions as to the legality of conduct; (7) you may not post any false or misleading statements; and (8) you may not organize a campaign encouraging others to post reviews, whether positive or negative.",
      "We may accept, reject, or remove reviews in our sole discretion. We have absolutely no obligation to screen reviews or to delete reviews, even if anyone considers reviews objectionable or inaccurate. Reviews are not endorsed by us, and do not necessarily represent our opinions or the views of any of our affiliates or partners. We do not assume liability for any review or for any claims, liabilities, or losses resulting from any review. By posting a review, you hereby grant to us a perpetual, non-exclusive, worldwide, royalty-free, fully paid, assignable, and sublicensable right and license to reproduce, modify, translate, transmit by any means, display, perform, and/or distribute all content relating to review.",
      "12. SOCIAL MEDIA",
      "As part of the functionality of the Services, you may link your account with online accounts you have with third-party service providers (each such account, a \"Third-Party Account\") by either: (1) providing your Third-Party Account login information through the Services; or (2) allowing us to access your Third-Party Account, as is permitted under the applicable terms and conditions that govern your use of each Third-Party Account. You represent and warrant that you are entitled to disclose your Third-Party Account login information to us and/or grant us access to your Third-Party Account, without breach by you of any of the terms and conditions that govern your use of the applicable Third-Party Account, and without obligating us to pay any fees or making us subject to any usage limitations imposed by the third-party service provider of the Third-Party Account. By granting us access to any Third-Party Accounts, you understand that (1) we may access, make available, and store (if applicable) any content that you have provided to and stored in your Third-Party Account (the \"Social Network Content\") so that it is available on and through the Services via your account, including without limitation any friend lists and (2) we may submit to and receive from your Third-Party Account additional information to the extent you are notified when you link your account with the Third-Party Account. Depending on the Third-Party Accounts you choose and subject to the privacy settings that you have set in such Third-Party Accounts, personally identifiable information that you post to your Third-Party Accounts may be available on and through your account on the Services. Please note that if a Third-Party Account or associated service becomes unavailable or our access to such Third-Party Account is terminated by the third-party service provider, then Social Network Content may no longer be available on and through the Services. You will have the ability to disable the connection between your account on the Services and your Third-Party Accounts at any time. PLEASE NOTE THAT YOUR RELATIONSHIP WITH THE THIRD-PARTY SERVICE PROVIDERS ASSOCIATED WITH YOUR THIRD-PARTY ACCOUNTS IS GOVERNED SOLELY BY YOUR AGREEMENT(S) WITH SUCH THIRD-PARTY SERVICE PROVIDERS. We make no effort to review any Social Network Content for any purpose, including but not limited to, for accuracy, legality, or non-infringement, and we are not responsible for any Social Network Content. You acknowledge and agree that we may access your email address book associated with a Third-Party Account and your contacts list stored on your mobile device or tablet computer solely for purposes of identifying and informing you of those contacts who have also registered to use the Services. You can deactivate the connection between the Services and your Third-Party Account by contacting us using the contact information below or through your account settings (if applicable). We will attempt to delete any information stored on our servers that was obtained through such Third-Party Account, except the username and profile picture that become associated with your account.",
      "13. THIRD-PARTY WEBSITES AND CONTENT",
      "The Services may contain (or you may be sent via the Site) links to other websites (\"Third-Party Websites\") as well as articles, photographs, text, graphics, pictures, designs, music, sound, video, information, applications, software, and other content or items belonging to or originating from third parties (\"Third-Party Content\"). Such Third-Party Websites and Third-Party Content are not investigated, monitored, or checked for accuracy, appropriateness, or completeness by us, and we are not responsible for any Third-Party Websites accessed through the Services or any Third-Party Content posted on, available through, or installed from the Services, including the content, accuracy, offensiveness, opinions, reliability, privacy practices, or other policies of or contained in the Third-Party Websites or the Third-Party Content. Inclusion of, linking to, or permitting the use or installation of any Third-Party Websites or any Third-Party Content does not imply approval or endorsement thereof by us. If you decide to leave the Services and access the Third-Party Websites or to use or install any Third-Party Content, you do so at your own risk, and you should be aware these Legal Terms no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any website to which you navigate from the Services or relating to any applications you use or install from the Services. Any purchases you make through Third-Party Websites will be through other websites and from other companies, and we take no responsibility whatsoever in relation to such purchases which are exclusively between you and the applicable third party. You agree and acknowledge that we do not endorse the products or services offered on Third-Party Websites and you shall hold us blameless from any harm caused by your purchase of such products or services. Additionally, you shall hold us blameless from any losses sustained by you or harm caused to you relating to or resulting in any way from any Third-Party Content or any contact with Third-Party Websites.",
      "14. ADVERTISERS",
      "We allow advertisers to display their advertisements and other information in certain areas of the Services, such as sidebar advertisements or banner advertisements. We simply provide the space to place such advertisements, and we have no other relationship with advertisers.",
      "15. SERVICES MANAGEMENT",
      "We reserve the right, but not the obligation, to: (1) monitor the Services for violations of these Legal Terms; (2) take appropriate legal action against anyone who, in our sole discretion, violates the law or these Legal Terms, including without limitation, reporting such user to law enforcement authorities; (3) in our sole discretion and without limitation, refuse, restrict access to, limit the availability of, or disable (to the extent technologically feasible) any of your Contributions or any portion thereof; (4) in our sole discretion and without limitation, notice, or liability, to remove from the Services or otherwise disable all files and content that are excessive in size or are in any way burdensome to our systems; and (5) otherwise manage the Services in a manner designed to protect our rights and property and to facilitate the proper functioning of the Services.",
      "16. PRIVACY POLICY",
      "We care about data privacy and security. Please review our Privacy Policy: https://windmillcode.com/legal/privacy-policy. By using the Services, you agree to be bound by our Privacy Policy, which is incorporated into these Legal Terms. Please be advised the Services are hosted in the United States. If you access the Services from any other region of the world with laws or other requirements governing personal data collection, use, or disclosure that differ from applicable laws in the United States, then through your continued use of the Services, you are transferring your data to the United States, and you expressly consent to have your data transferred to and processed in the United States.",
      "17. COPYRIGHT INFRINGEMENTS",
      "We respect the intellectual property rights of others. If you believe that any material available on or through the Services infringes upon any copyright you own or control, please immediately notify us using the contact information provided below (a \"Notification\"). A copy of your Notification will be sent to the person who posted or stored the material addressed in the Notification. Please be advised that pursuant to applicable law you may be held liable for damages if you make material misrepresentations in a Notification. Thus, if you are not sure that material located on or linked to by the Services infringes your copyright, you should consider first contacting an attorney.",
      "18. TERM AND TERMINATION",
      "These Legal Terms shall remain in full force and effect while you use the Services. WITHOUT LIMITING ANY OTHER PROVISION OF THESE LEGAL TERMS, WE RESERVE THE RIGHT TO, IN OUR SOLE DISCRETION AND WITHOUT NOTICE OR LIABILITY, DENY ACCESS TO AND USE OF THE SERVICES (INCLUDING BLOCKING CERTAIN IP ADDRESSES), TO ANY PERSON FOR ANY REASON OR FOR NO REASON, INCLUDING WITHOUT LIMITATION FOR BREACH OF ANY REPRESENTATION, WARRANTY, OR COVENANT CONTAINED IN THESE LEGAL TERMS OR OF ANY APPLICABLE LAW OR REGULATION. WE MAY TERMINATE YOUR USE OR PARTICIPATION IN THE SERVICES OR DELETE YOUR ACCOUNT AND ANY CONTENT OR INFORMATION THAT YOU POSTED AT ANY TIME, WITHOUT WARNING, IN OUR SOLE DISCRETION.",
      "If we terminate or suspend your account for any reason, you are prohibited from registering and creating a new account under your name, a fake or borrowed name, or the name of any third party, even if you may be acting on behalf of the third party. In addition to terminating or suspending your account, we reserve the right to take appropriate legal action, including without limitation pursuing civil, criminal, and injunctive redress.",
      "19. MODIFICATIONS AND INTERRUPTIONS",
      "We reserve the right to change, modify, or remove the contents of the Services at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Services. We also reserve the right to modify or discontinue all or part of the Services without notice at any time. We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Services.",
      "We cannot guarantee the Services will be available at all times. We may experience hardware, software, or other problems or need to perform maintenance related to the Services, resulting in interruptions, delays, or errors. We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Services at any time or for any reason without notice to you. You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Services during any downtime or discontinuance of the Services. Nothing in these Legal Terms will be construed to obligate us to maintain and support the Services or to supply any corrections, updates, or releases in connection therewith.",
      "20. GOVERNING LAW",
      "These Legal Terms and your use of the Services are governed by and construed in accordance with the laws of the State of New York applicable to agreements made and to be entirely performed within the State of New York, without regard to its conflict of law principles.",
      "21. DISPUTE RESOLUTION",
      "Informal Negotiations",
      "To expedite resolution and control the cost of any dispute, controversy, or claim related to these Legal Terms (each a \"Dispute\" and collectively, the \"Disputes\") brought by either you or us (individually, a \"Party\" and collectively, the \"Parties\"), the Parties agree to first attempt to negotiate any Dispute (except those Disputes expressly provided below) informally for at least thirty (30) days before initiating arbitration. Such informal negotiations commence upon written notice from one Party to the other Party.",
      "Binding Arbitration",
      "If the Parties are unable to resolve a Dispute through informal negotiations, the Dispute (except those Disputes expressly excluded below) will be finally and exclusively resolved by binding arbitration. YOU UNDERSTAND THAT WITHOUT THIS PROVISION, YOU WOULD HAVE THE RIGHT TO SUE IN COURT AND HAVE A JURY TRIAL. The arbitration shall be commenced and conducted under the Commercial Arbitration Rules of the American Arbitration Association (\"AAA\") and, where appropriate, the AAA’s Supplementary Procedures for Consumer Related Disputes (\"AAA Consumer Rules\"), both of which are available at the American Arbitration Association (AAA) website. Your arbitration fees and your share of arbitrator compensation shall be governed by the AAA Consumer Rules and, where appropriate, limited by the AAA Consumer Rules. The arbitration may be conducted in person, through the submission of documents, by phone, or online. The arbitrator will make a decision in writing, but need not provide a statement of reasons unless requested by either Party. The arbitrator must follow applicable law, and any award may be challenged if the arbitrator fails to do so. Except where otherwise required by the applicable AAA rules or applicable law, the arbitration will take place in New York, New York. Except as otherwise provided herein, the Parties may litigate in court to compel arbitration, stay proceedings pending arbitration, or to confirm, modify, vacate, or enter judgment on the award entered by the arbitrator.",
      "If for any reason, a Dispute proceeds in court rather than arbitration, the Dispute shall be commenced or prosecuted in the state and federal courts located in New York, New York, and the Parties hereby consent to, and waive all defenses of lack of personal jurisdiction, and forum non conveniens with respect to venue and jurisdiction in such state and federal courts. Application of the United Nations Convention on Contracts for the International Sale of Goods and the Uniform Computer Information Transaction Act (UCITA) are excluded from these Legal Terms.",
      "In no event shall any Dispute brought by either Party related in any way to the Services be commenced more than one (1) years after the cause of action arose. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.",
      "Restrictions",
      "The Parties agree that any arbitration shall be limited to the Dispute between the Parties individually. To the full extent permitted by law, (a) no arbitration shall be joined with any other proceeding; (b) there is no right or authority for any Dispute to be arbitrated on a class-action basis or to utilize class action procedures; and (c) there is no right or authority for any Dispute to be brought in a purported representative capacity on behalf of the general public or any other persons.",
      "Exceptions to Informal Negotiations and Arbitration",
      "The Parties agree that the following Disputes are not subject to the above provisions concerning informal negotiations binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.",
      "Exceptions to Informal Negotiations and Arbitration",
      "The Parties agree that the following Disputes are not subject to the above provisions concerning informal negotiations binding arbitration: (a) any Disputes seeking to enforce or protect, or concerning the validity of, any of the intellectual property rights of a Party; (b) any Dispute related to, or arising from, allegations of theft, piracy, invasion of privacy, or unauthorized use; and (c) any claim for injunctive relief. If this provision is found to be illegal or unenforceable, then neither Party will elect to arbitrate any Dispute falling within that portion of this provision found to be illegal or unenforceable and such Dispute shall be decided by a court of competent jurisdiction within the courts listed for jurisdiction above, and the Parties agree to submit to the personal jurisdiction of that court.",
      "22. CORRECTIONS",
      "There may be information on the Services that contains typographical errors, inaccuracies, or omissions, including descriptions, pricing, availability, and various other information. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update the information on the Services at any time, without prior notice.",
      "23. DISCLAIMER",
      "THE SERVICES ARE PROVIDED ON AN AS-IS AND AS-AVAILABLE BASIS. YOU AGREE THAT YOUR USE OF THE SERVICES WILL BE AT YOUR SOLE RISK. TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES, EXPRESS OR IMPLIED, IN CONNECTION WITH THE SERVICES AND YOUR USE THEREOF, INCLUDING, WITHOUT LIMITATION, THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NON-INFRINGEMENT. WE MAKE NO WARRANTIES OR REPRESENTATIONS ABOUT THE ACCURACY OR COMPLETENESS OF THE SERVICES' CONTENT OR THE CONTENT OF ANY WEBSITES OR MOBILE APPLICATIONS LINKED TO THE SERVICES AND WE WILL ASSUME NO LIABILITY OR RESPONSIBILITY FOR ANY (1) ERRORS, MISTAKES, OR INACCURACIES OF CONTENT AND MATERIALS, (2) PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER, RESULTING FROM YOUR ACCESS TO AND USE OF THE SERVICES, (3) ANY UNAUTHORIZED ACCESS TO OR USE OF OUR SECURE SERVERS AND/OR ANY AND ALL PERSONAL INFORMATION AND/OR FINANCIAL INFORMATION STORED THEREIN, (4) ANY INTERRUPTION OR CESSATION OF TRANSMISSION TO OR FROM THE SERVICES, (5) ANY BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE WHICH MAY BE TRANSMITTED TO OR THROUGH THE SERVICES BY ANY THIRD PARTY, AND/OR (6) ANY ERRORS OR OMISSIONS IN ANY CONTENT AND MATERIALS OR FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF ANY CONTENT POSTED, TRANSMITTED, OR OTHERWISE MADE AVAILABLE VIA THE SERVICES. WE DO NOT WARRANT, ENDORSE, GUARANTEE, OR ASSUME RESPONSIBILITY FOR ANY PRODUCT OR SERVICE ADVERTISED OR OFFERED BY A THIRD PARTY THROUGH THE SERVICES, ANY HYPERLINKED WEBSITE, OR ANY WEBSITE OR MOBILE APPLICATION FEATURED IN ANY BANNER OR OTHER ADVERTISING, AND WE WILL NOT BE A PARTY TO OR IN ANY WAY BE RESPONSIBLE FOR MONITORING ANY TRANSACTION BETWEEN YOU AND ANY THIRD-PARTY PROVIDERS OF PRODUCTS OR SERVICES. AS WITH THE PURCHASE OF A PRODUCT OR SERVICE THROUGH ANY MEDIUM OR IN ANY ENVIRONMENT, YOU SHOULD USE YOUR BEST JUDGMENT AND EXERCISE CAUTION WHERE APPROPRIATE.",
      "24. LIMITATIONS OF LIABILITY",
      "IN NO EVENT WILL WE OR OUR DIRECTORS, EMPLOYEES, OR AGENTS BE LIABLE TO YOU OR ANY THIRD PARTY FOR ANY DIRECT, INDIRECT, CONSEQUENTIAL, EXEMPLARY, INCIDENTAL, SPECIAL, OR PUNITIVE DAMAGES, INCLUDING LOST PROFIT, LOST REVENUE, LOSS OF DATA, OR OTHER DAMAGES ARISING FROM YOUR USE OF THE SERVICES, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, OUR LIABILITY TO YOU FOR ANY CAUSE WHATSOEVER AND REGARDLESS OF THE FORM OF THE ACTION, WILL AT ALL TIMES BE LIMITED TO THE AMOUNT PAID, IF ANY, BY YOU TO US. CERTAIN US STATE LAWS AND INTERNATIONAL LAWS DO NOT ALLOW LIMITATIONS ON IMPLIED WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN DAMAGES. IF THESE LAWS APPLY TO YOU, SOME OR ALL OF THE ABOVE DISCLAIMERS OR LIMITATIONS MAY NOT APPLY TO YOU, AND YOU MAY HAVE ADDITIONAL RIGHTS.",
      "25. INDEMNIFICATION",
      "You agree to defend, indemnify, and hold us harmless, including our subsidiaries, affiliates, and all of our respective officers, agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable attorneys’ fees and expenses, made by any third party due to or arising out of: (1) your Contributions; (2) use of the Services; (3) breach of these Legal Terms; (4) any breach of your representations and warranties set forth in these Legal Terms; (5) your violation of the rights of a third party, including but not limited to intellectual property rights; or (6) any overt harmful act toward any other user of the Services with whom you connected via the Services. Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims. We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.",
      "26. USER DATA",
      "We will maintain certain data that you transmit to the Services for the purpose of managing the performance of the Services, as well as data relating to your use of the Services. Although we perform regular routine backups of data, you are solely responsible for all data that you transmit or that relates to any activity you have undertaken using the Services. You agree that we shall have no liability to you for any loss or corruption of any such data, and you hereby waive any right of action against us arising from any such loss or corruption of such data.",
      "27. ELECTRONIC COMMUNICATIONS, TRANSACTIONS, AND SIGNATURES",
      "Visiting the Services, sending us emails, and completing online forms constitute electronic communications. You consent to receive electronic communications, and you agree that all agreements, notices, disclosures, and other communications we provide to you electronically, via email and on the Services, satisfy any legal requirement that such communication be in writing. YOU HEREBY AGREE TO THE USE OF ELECTRONIC SIGNATURES, CONTRACTS, ORDERS, AND OTHER RECORDS, AND TO ELECTRONIC DELIVERY OF NOTICES, POLICIES, AND RECORDS OF TRANSACTIONS INITIATED OR COMPLETED BY US OR VIA THE SERVICES. You hereby waive any rights or requirements under any statutes, regulations, rules, ordinances, or other laws in any jurisdiction which require an original signature or delivery or retention of non-electronic records, or to payments or the granting of credits by any means other than electronic means.",
      "28. CALIFORNIA USERS AND RESIDENTS",
      "If any complaint with us is not satisfactorily resolved, you can contact the Complaint Assistance Unit of the Division of Consumer Services of the California Department of Consumer Affairs in writing at 1625 North Market Blvd., Suite N 112, Sacramento, California 95834 or by telephone at (800) 952-5210 or (916) 445-1254.",
      "29. MISCELLANEOUS",
      "These Legal Terms and any policies or operating rules posted by us on the Services or in respect to the Services constitute the entire agreement and understanding between you and us. Our failure to exercise or enforce any right or provision of these Legal Terms shall not operate as a waiver of such right or provision. These Legal Terms operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control. If any provision or part of a provision of these Legal Terms is determined to be unlawful, void, or unenforceable, that provision or part of the provision is deemed severable from these Legal Terms and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership, employment or agency relationship created between you and us as a result of these Legal Terms or use of the Services. You agree that these Legal Terms will not be construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Legal Terms and the lack of signing by the parties hereto to execute these Legal Terms.",
      "30. CONTACT US",
      "In order to resolve a complaint regarding the Services or to receive further information regarding use of the Services, please contact us at:",
      "Windmillcode",
      "__________",
      "contact@windmillcode.com"
    ]
  },
  "ProductsZero": {
    "toggleAIPricing": "Toggle AI Pricing",
    "toggleAIPricingOn": "On",
    "toggleAIPricingOff": "Off",
    "WMLTable": {
      "controlItems": {
        "previous": "Previous",
        "next": "Next",
        "selectPage": "Select Page",
        "itemsPerPage": "Items Per Page",
        "filter": "Filter",
        "sort": "Sort",
        "page": "Page",
        "pageSize": "Page Size"
      },
      "selectPage": {
        "title": "Select Page"
      },
      "rowType": {
        "title": "Select Row Type",
        "options": [
          "Card"
        ]
      },
      "pageSize": {
        "title": "Enter Page Size"
      },
      "filter": {
        "title": "Modify Filters",
        "subtitles": [
          "Filter values filter based on the beginning of the word in the column",
          "To specify global filter leave the Filter Key input empty"
        ],
        "columnText": "Available Columns",
        "add0BtnText": "Add Filter",
        "remove0BtnText": "Remove",
        "submit0Btn": "Submit",
        "fieldLabels": [
          "Filter Column",
          "Filter Value"
        ]
      },
      "sort": {
        "title": "Modify Sorting",
        "subtitles": [
          "Sort values filter based on the beginning of the word in the column",
          "To specify global filter leave the Sort Key input empty"
        ],
        "columnText": "Available Columns",
        "add0BtnText": "Add Sort",
        "remove0BtnText": "Remove",
        "submit0Btn": "Submit",
        "availableColumnsText": "",
        "fieldLabels": [
          "Sort Column",
          "Sort Direction"
        ],
        "sortDirectionParamsOptions": [
          "ASC",
          "DESC"
        ]
      }
    }
  },
  "SignUpSignIn": {
    "wmlNotify":{
      "tosMustBeAccepted":"You must agree to the Terms of Service and Privacy Policy in order to create an account."
    },
    "loginAgreement": [
      "By clicking this checkbox, you are indicating that you accept our ",
      "Terms of Service ",
      "and ",
      "Privacy Policy "
    ]
  },
  "SignUp": {
    "google": "Sign up with google",
    "microsoft": "Sign up with microsoft",
    "facebook": "Sign up with facebook",
    "yahoo": "Sign up with with yahoo",
    "github": "Sign up with github",
    "twitter": "Sign up with twitter"
  },
  "SignIn": {
    "google": "Sign in with google",
    "microsoft": "Sign in with microsoft",
    "facebook": "Sign in with facebook",
    "yahoo": "Sign in with with yahoo",
    "github": "Sign in with github",
    "twitter": "Sign in with twitter"
  },
  "ProductDetailZero": {
    "price": {
      "title": "Price"
    },
    "rating": {
      "title": "Rating"
    },
    "mainForm": {
      "quantityField": {
        "label": "Quantity",
        "error": {
          "min": "The value must be greater than 0",
          "digit": "The value must be an integer number or a digit"
        }
      },
      "colorField": {
        "label": "Color",
        "error": {}
      },
      "sizeField": {
        "label": "Size",
        "error": {}
      }
    }
  },
  "ImageUploadZero": {

  }
}
